import Vue from 'vue'
import App from './AppShell.vue'
import router from './router'
import axios from 'axios'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueTypedJs from 'vue-typed-js'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const sessionApiBases = [
  process.env.VUE_APP_API_BASE,
  "https://api.ntustmeg.com",
  "https://devapi.ntustmeg.com",
  "http://127.0.0.1:8081",
  "http://localhost:8081",
].filter(Boolean);

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("session_token");
    const url = config.url || "";

    const isSessionApi =
      sessionApiBases.some((base) => url.startsWith(base)) ||
      (config.baseURL &&
        sessionApiBases.some((base) => config.baseURL.includes(base)));

    if (token && isSessionApi) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("session_token");
      localStorage.removeItem("game_id");

      if (router.currentRoute.path !== "/login") {
        router.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false
Vue.use(VueTypedJs)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
